import { MEMBERSHIP_SKUS } from "../../../DiscoveryJourneyModal";
import type { GiftContentResponse, SamplesCardContentProps } from "./types";

export const samplesCardContent = ({
  samples,
  samplesThreshold,
  currencySymbol,
  currentMembershipSku
}: SamplesCardContentProps): GiftContentResponse | null => {
  const commonContent = {
    imageUrl:
      "https://beautypie.bynder.com/m/166e50865a5e6edb/webimage-SAMPLES_WEB.jpg",
    title: "Free Sample"
  };

  if (samples) {
    return {
      ...commonContent,
      description: `Unlock a FREE sample when you spend over ${currencySymbol}${samplesThreshold}`
    };
  }

  if (MEMBERSHIP_SKUS.freeTrial.includes(currentMembershipSku)) {
    return {
      ...commonContent,
      description: `Get a FREE sample with orders over ${currencySymbol}${samplesThreshold} when you become a fully-fledged Beauty Pie+ member`
    };
  }

  return null;
};
